import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";

import {
    deletedRestoreStudy,
    deletedStudyYears,
    setStudyRestoreData,
    setStudyYears,
    updateStudyYears
} from "./studyYearsSlice";
import {IErrorResponse} from "../../../../types";
import {IEditStudyYears, IStudyYearsCreate} from "../types";




const GetStudyYears = createAsyncThunk(
    "get/study/years",
    async (_, { dispatch ,rejectWithValue}) => {
        try {
            const response = await request.get("/study-years");
            dispatch(setStudyYears(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const SetStudyYears = createAsyncThunk(
    "set/study/years",
    async (data: IStudyYearsCreate, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post("/study-years", data);
            dispatch(setStudyYears(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const DeleteStudyYears = createAsyncThunk(
    "delete/study/years",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/study-years/${id}`);

             dispatch(deletedStudyYears(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const EditStudyYears = createAsyncThunk(
    "edit/academic/term",
    async ({ data }: IEditStudyYears, {dispatch, rejectWithValue }) => {
        try {

            const response = await request.put(`/study-years/${data.id}`, data);
            dispatch(updateStudyYears(data));
            return response.data;

        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const GetDeleteStudy= createAsyncThunk(
    "get/delete/study",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/study-years/deleted-items`);

            dispatch(setStudyRestoreData(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const RestoreDeleteStudy = createAsyncThunk(
    "restore/delete/study",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/study-years/restore/${id}`);

            dispatch(deletedRestoreStudy(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


export {
    GetStudyYears,
    SetStudyYears,
    DeleteStudyYears,
    EditStudyYears,
    GetDeleteStudy,
    RestoreDeleteStudy

}